import { apiPost, apiGet } from '../lib/apiClient';
import type { AuthUser, LoginResponse } from '../types/auth';

export function login(identifier: string, password: string): Promise<LoginResponse> {
  return apiPost<LoginResponse>('/auth/login', { identifier, password });
}

export function logout(): Promise<null> {
  return apiPost<null>('/auth/logout', {});
}

export function fetchCurrentUser(): Promise<{ user: AuthUser }> {
  return apiGet<{ user: AuthUser }>('/auth/me');
}
